<template>
  <!-- <div>
    ID: {{hash}},
    P: {{$parent.activeTabHash}},
    ACTIVE: {{isActive}},
    LOADED: {{isLoaded}},
    LAZY: {{lazy}}, -->
    <section
      v-if="(!lazy || isLoaded) || isActive"
      v-show="isActive"
      :aria-hidden="!isActive"
      class="tabs-component-panel"
      :id="id"
      role="tabpanel">
      <!-- <el-button @click="deselectTab" class="close-button">X</el-button> -->
      <slot />
    </section>
  <!-- </div> -->
</template>

<script>
export default {
  name: "SidebarTabElement",
  props: {
    lazy: { default: false },
    id: { default: null, required: true },
    name: { default: '' },
    isDisabled: { default: false }
  },
  data: () => ({
    isLoaded: false,
    isVisible: true,
    isActive: false
  }),
  watch: {
    '$parent.activeTabHash': {
      handler() { this.update() },
      immediate: true
    },
    hash() { this.update() }
  },
  computed: {
    hash() {
      return this.id ? '#' + this.id : '#';
    },
  },
  methods: {
    update() {
      this.isActive = this.$parent.activeTabHash === this.hash;

      if ( this.isActive ) {
        // console.log("LOADING TAB", this.id);
        this.isLoaded = true;
      }
    },
    deselectTab() {
      this.$parent.deselectAllTabs();
    }
  }
};
</script>
